import { Phone, Mail, MapPin } from "lucide-react";

const ContactInfo = () => {
  const items = [
    {
      icon: Phone,
      title: "Phone",
      text: "+255 XXX XXX XXX",
    },
    {
      icon: Mail,
      title: "Email",
      text: "info@afyaequip.com",
    },
    {
      icon: MapPin,
      title: "Location",
      text: "Dar es Salaam, Tanzania",
    },
  ];

  return (
    <div className="space-y-6">
      {items.map((item, index) => {
        const Icon = item.icon;

        return (
          <div key={index} className="flex gap-4 items-start">
            
            <div className="w-12 h-12 md:w-16 md:h-16 rounded-xl bg-green-100 flex items-center justify-center">
              <Icon className="text-green-600" />
            </div>

            <div>
              <h3 className="font-semibold text-gray-900">
                {item.title}
              </h3>

              <p className="text-gray-600 mt-1">
                {item.text}
              </p>
            </div>

          </div>
        );
      })}
    </div>
  );
};

export default ContactInfo;